/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsProductSection3 = {
  init: function ($section) {
    
    // Add settings from schema to current object
    // window.PXUTheme.jsProductSection4 = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);

    this.animationDuration = 0.3;
    
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 1],
    }

    this.observer = new IntersectionObserver(this.sequentialFadeText.bind(this), options);
    this.observer.observe(this.element.querySelector(".Section_3--text"));
    this.setDelayForParagraphs();
  },
  sequentialFadeText(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio === 1) {
        entry.target.classList.add("appear");
      } 
      if (!entry.isIntersecting && entry.intersectionRatio === 0) {
        entry.target.classList.remove("appear");
      }
    });
  },
  setDelayForParagraphs() {
    let paragraphs = Array.from(this.element.querySelectorAll(".Section_3--text p"));
    paragraphs.forEach( (p, index) => {
      p.style.setProperty("transition-duration", `${this.animationDuration}s`);
      p.style.setProperty("transition-delay", `${index*this.animationDuration}s`);
    })
  }
}

/******/ })()
;